/* unplugin-vue-components disabled */import { render } from "./Youzi.vue?vue&type=template&id=944e1e62&scoped=true"
import script from "./Youzi.vue?vue&type=script&lang=js"
export * from "./Youzi.vue?vue&type=script&lang=js"

import "./Youzi.vue?vue&type=style&index=0&id=944e1e62&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944e1e62"]])

export default __exports__